import { FormScrollTo } from "@modules";
import { init } from "@utilities";

declare global {
  interface Window {
    scrollToFormContainerForm: () => void;
  }
}

const CONTAINER_TOP_SPACING = 24;

export default () => {
  const containerEl = document.querySelector(".form-container__scroll");
  const submitButtonEl = containerEl.querySelector("input[type='submit']");
  if (!containerEl || !submitButtonEl) return;

  const containerElDOMRect = containerEl.getBoundingClientRect(); // get container dimensions
  const containerElPositionFromTop = containerElDOMRect.top; // get position from top of the window

  const pageCurrentScrollPosition = window.pageYOffset;

  const landingPositionForTheScrollEvent =
    containerElPositionFromTop + pageCurrentScrollPosition - CONTAINER_TOP_SPACING;

  // submitButtonEl.addEventListener("click", () => {
  //  setTimeout(() => {
  //    window.scrollTo({
  //      top: landingPositionForTheScrollEvent,
  //      behavior: "smooth",
  //    });
  //  }, 100);
  // });

  const scrollToFormContainer = () => {
    setTimeout(() => {
      window.scrollTo({
        top: landingPositionForTheScrollEvent,
        behavior: "smooth",
      });
    }, 100);
  };

  window.scrollToFormContainerForm = scrollToFormContainer;
};